module.exports = __webpack_public_path__ + "static/media/moto_derecha.47359686.png";